import { timeStampNow } from '../../tools/utils/timeUtils';
import { normalizeUrl } from '../../tools/utils/urlPolyfill';
import { generateUUID } from '../../tools/utils/stringUtils';
import { INTAKE_SITE_FED_STAGING, INTAKE_SITE_US1, PCI_INTAKE_HOST_US1 } from '../intakeSites';
export function createEndpointBuilder(initConfiguration, trackType, extraParameters) {
  var buildUrlWithParameters = createEndpointUrlWithParametersBuilder(initConfiguration, trackType);
  return {
    build: function build(api, payload) {
      var parameters = buildEndpointParameters(initConfiguration, trackType, api, payload, extraParameters);
      return buildUrlWithParameters(parameters);
    },
    trackType: trackType
  };
}
/**
 * Create a function used to build a full endpoint url from provided parameters. The goal of this
 * function is to pre-compute some parts of the URL to avoid re-computing everything on every
 * request, as only parameters are changing.
 */
function createEndpointUrlWithParametersBuilder(initConfiguration, trackType) {
  var path = "/api/v2/".concat(trackType);
  var proxy = initConfiguration.proxy;
  if (typeof proxy === 'string') {
    var normalizedProxyUrl = normalizeUrl(proxy);
    return function (parameters) {
      return "".concat(normalizedProxyUrl, "?ddforward=").concat(encodeURIComponent("".concat(path, "?").concat(parameters)));
    };
  }
  if (typeof proxy === 'function') {
    return function (parameters) {
      return proxy({
        path: path,
        parameters: parameters
      });
    };
  }
  var host = buildEndpointHost(trackType, initConfiguration);
  return function (parameters) {
    return "https://".concat(host).concat(path, "?").concat(parameters);
  };
}
export function buildEndpointHost(trackType, initConfiguration) {
  var _initConfiguration$si = initConfiguration.site,
    site = _initConfiguration$si === void 0 ? INTAKE_SITE_US1 : _initConfiguration$si,
    internalAnalyticsSubdomain = initConfiguration.internalAnalyticsSubdomain;
  if (trackType === 'logs' && initConfiguration.usePciIntake && site === INTAKE_SITE_US1) {
    return PCI_INTAKE_HOST_US1;
  }
  if (internalAnalyticsSubdomain && site === INTAKE_SITE_US1) {
    return "".concat(internalAnalyticsSubdomain, ".").concat(INTAKE_SITE_US1);
  }
  if (site === INTAKE_SITE_FED_STAGING) {
    return "http-intake.logs.".concat(site);
  }
  var domainParts = site.split('.');
  var extension = domainParts.pop();
  return "browser-intake-".concat(domainParts.join('-'), ".").concat(extension);
}
/**
 * Build parameters to be used for an intake request. Parameters should be re-built for each
 * request, as they change randomly.
 */
function buildEndpointParameters(_ref, trackType, api, _ref2) {
  var clientToken = _ref.clientToken,
    internalAnalyticsSubdomain = _ref.internalAnalyticsSubdomain,
    _ref$source = _ref.source,
    source = _ref$source === void 0 ? 'browser' : _ref$source;
  var retry = _ref2.retry,
    encoding = _ref2.encoding;
  var extraParameters = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : [];
  var parameters = ["ddsource=".concat(source), "dd-api-key=".concat(clientToken), "dd-evp-origin-version=".concat(encodeURIComponent("6.31.0")), 'dd-evp-origin=browser', "dd-request-id=".concat(generateUUID())].concat(extraParameters);
  if (encoding) {
    parameters.push("dd-evp-encoding=".concat(encoding));
  }
  if (trackType === 'rum') {
    parameters.push("batch_time=".concat(timeStampNow()), "_dd.api=".concat(api));
    if (retry) {
      parameters.push("_dd.retry_count=".concat(retry.count), "_dd.retry_after=".concat(retry.lastFailureStatus));
    }
  }
  if (internalAnalyticsSubdomain) {
    parameters.reverse();
  }
  return parameters.join('&');
}